module.exports = __webpack_public_path__ + "static/media/lingo_intro_screen.ec5eaca6.png";